import { AnyAction } from 'redux';
import * as ActionType from '../../actions/ActionTypes';
import { ISettingReducerState } from './ISettingReducer';

const initialState: ISettingReducerState = {
  ColumnSortSettingObject: [],
  ColumnFilterSettingObject: {}
};

const settingReducer = (oldState: ISettingReducerState = initialState , action: AnyAction): ISettingReducerState => {
  let newState: ISettingReducerState = { ...oldState }
  switch (action.type) {
    case ActionType.SET_COLUMN_SORT_SETTINGS:
      newState.ColumnSortSettingObject = action.payload
      break;
    case ActionType.SET_COLUMN_FILTER_SETTINGS:
      newState.ColumnFilterSettingObject = action.payload
      break;
  }
  return newState;
}

export default settingReducer;